var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require("../assets/前端/2a547eb7cd4682abcb793549b52f97d.png")}})])}]

export { render, staticRenderFns }